import { createPatch } from 'rfc6902';
import { uuidv7 } from 'uuidv7';
import { PatientTherapySequenceStatus } from '../../database/schema.js';
import { EventLogs } from '../../utils.js';
import { addEventLog, EventLogResources } from '../util.js';
import { itemsDetail } from '../../util/event-log-items.js';
import { statusChangeItems } from './medicine-log-items.js';
/**
 * Cancelled prescriptions keep their row (and medicines) so the protocol history stays visible;
 * only their status changes.
 */
export function buildCancelSequenceOps(tx, seq, context) {
    const cancelled = {
        status: PatientTherapySequenceStatus.enum.cancelled,
        cancelledBy: context.userId,
        cancelledAt: context.now,
        cancellationReason: context.reason ?? null,
        updatedAt: context.now,
        updatedBy: context.userId,
    };
    const sequenceOps = [() => tx.mutate.patientTherapySequence.update({ id: seq.id, ...cancelled })];
    const logOps = [];
    if (tx.location === 'server') {
        logOps.push(() => addEventLog(tx, {
            id: uuidv7(),
            resource: EventLogResources.patientTherapySequence,
            resourceId: seq.id,
            action: 'update',
            domain: 'prescription',
            event: EventLogs.PATIENT_THERAPY_SEQUENCE_PROTOCOL_UPDATED,
            patches: createPatch(seq, { ...seq, ...cancelled }),
            performedBy: context.userId,
            performedAt: context.now,
            details: {
                therapyInternalId: seq.internalId,
                patientId: context.patientId,
                patientName: context.patientName,
                reason: context.reason,
                variant: 'cancelled',
                ...itemsDetail(statusChangeItems(seq.status, cancelled.status)),
            },
        }));
    }
    return { sequenceOps, logOps };
}
//# sourceMappingURL=cancel-protocol-sequences.js.map